/**
 * @name: snackbar
 * @author: Chuwen
 * @date: 2021-04-20 09:59
 * @description：snackbar
 * @update: 2021-04-20 09:59
 */

export default {
  /**
   * 弹出红色背景的 Snackbar
   * @param {String, Number} msg 提示内容
   * @param {Number} timeout  多少毫秒之后关闭，默认 4000ms
   * @param {Number} onButtonClick  点击关闭按钮的回调
   */
  error (msg, timeout, onButtonClick) {
    let status = 'danger'
    //解构赋值语法糖了解下
    this.show({ msg, timeout, onButtonClick, status })
  },

  /**
   * 默认背景色的 Snackbar
   * @param {String, Number} msg 提示内容
   * @param {Number} timeout  多少毫秒之后关闭，默认 4000ms
   * @param {Number} onButtonClick  点击关闭按钮的回调
   */
  info (msg, timeout, onButtonClick) {
    //解构赋值语法糖了解下
    this.show({ msg, timeout, onButtonClick })
  },

  /**
   * 总方法
   * @param {Object} config
   * msg: 提示的信息
   * timeout: 多少毫秒之后关闭，默认 4000ms
   * status: Snackbar 状态，当前只有 danger 这一个
   * onButtonClick: 点击关闭按钮的回调事件
   */
  show (config) {
    let div = document.createElement("div");

    div.className = 'pp-snackbar pp-snackbar-bottom ' + (config.status ? `pp-snackbar-${config.status}-status` : '')
    div.innerHTML = `<div class="pp-snackbar-text">${config.msg}</div>
      <a href="javascript:void(0)" class="pp-snackbar-action">
      <div class="Polaris-Icon">
        <svg viewBox="0 0 20 20" fill="currentColor" focusable="false" aria-hidden="true">
        <path d="M11.414 10l6.293-6.293a1 1 0 1 0-1.414-1.414L10 8.586 3.707 2.293a1 1 0 0 0-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 1 0 1.414 1.414L10 11.414l6.293 6.293A.998.998 0 0 0 18 17a.999.999 0 0 0-.293-.707L11.414 10z"></path>
        </svg>
      </div>
    </a>`

    //监听点击事件
    div.querySelector("a").addEventListener("click", () => {
      this.close(div)

      //如果参数类型是 function，那就执行回调
      if (typeof config.onButtonClick == "function") config.onButtonClick(div)
    })

    document.body.appendChild(div)

    //等待上面的插入完成后，再加入此动画
    setTimeout(() => {
      div.style = 'transform: translate(-50%, 0px);'
    }, 1)

    //如果设置的关闭时间为0，那么就不自动关闭
    if (config.timeout === 0) return
    var a;
    //如果没有指定时间，或者输入的时间小于1，默认4s后关闭
    if (!config.timeout || config.timeout < 1) {
      a = setTimeout(() => {
        this.close(div)
      }, 4000)
    } else {
      //指定时间后移除 Snackbar
      a = setTimeout(() => {
        this.close(div)
      }, config.timeout)
    }

    //监听鼠标悬停事件
    div.querySelector(".pp-snackbar-text").addEventListener("mouseover", () => {
      clearTimeout(a);
    })
    //监听鼠标离开事件
    div.querySelector(".pp-snackbar-text").addEventListener("mouseout", () => {
      setTimeout(() => {
        this.close(div)
      }, 2000)
    })
  },

  /**
   * 关闭动画
   * @param {HTMLDivElement} ele
   */
  close (ele) {
    ele.style = ''//动画清理
    setTimeout(() => {
      ele.remove()//移除 Snackbar
    }, 300)//300ms 后动画就消失了
  }

}
